let signatureExtension = [
  'B',
  'T',
  'LT',
  'LTA'
]

export default signatureExtension
